import type { PrimaryEntityId } from "building-types/doc/primaryEntityId";
import type { DocEntityBase } from "building-types/entities/docEntityBase";
import type { Table } from "common/data/table";
import type { Mat3 } from "geom/mat3";
import { ComponentVerticalPlacementType } from "./componentInstanceTypes";

export interface Component extends DocEntityBase<"COMPONENT"> {
  readonly id: PrimaryEntityId<"COMPONENT">;
  readonly name: string;
}

export interface ComponentTransformVerticalPlacementBase {
  readonly type: ComponentVerticalPlacementType;
}

export interface ComponentTransformVerticalPlacementRemapping extends ComponentTransformVerticalPlacementBase {
  readonly type: ComponentVerticalPlacementType.REMAPPING;
  readonly levelRemapping: Table<string>;
}

export interface ComponentTransformVerticalPlacementReplication extends ComponentTransformVerticalPlacementBase {
  readonly type: ComponentVerticalPlacementType.REPLICATION;
  readonly offset: number;
}

export type ComponentTransformVerticalPlacement =
  | ComponentTransformVerticalPlacementRemapping
  | ComponentTransformVerticalPlacementReplication;

export interface ComponentTransform {
  readonly instanceId: string;
  readonly sourceLevels: Set<string>;
  readonly componentInstanceChain: string[];
  readonly matrix: Mat3;
  // Precomputed inverse of `matrix`, populated when the transform is built so consumers that map
  // instance-space geometry back into the source frame don't recompute it on every call.
  readonly inverseMatrix?: Mat3;
  readonly verticalPlacement: ComponentTransformVerticalPlacement;
  readonly reverseOrientation: boolean;
  readonly mirrorX?: boolean;
  readonly mirrorY?: boolean;
}

export function createComponentTransformVerticalPlacementRemapping(
  levelRemapping: Table<string> = {},
): ComponentTransformVerticalPlacement {
  return {
    type: ComponentVerticalPlacementType.REMAPPING,
    levelRemapping,
  };
}

export function createComponentTransformVerticalPlacementReplication(
  offset: number = 0,
): ComponentTransformVerticalPlacement {
  return {
    type: ComponentVerticalPlacementType.REPLICATION,
    offset,
  };
}
